import { Stack, Typography } from "@mui/material";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useAsync } from "react-use";
import { useIdentity } from "../../containers/IdentityContainer";
import { Loading } from "../../widgets/Loading";
import { MagicLinkLoginButton } from "../Login";

export const MagicLinkLogin: React.FC<{}> = () => {
  const { t } = useTranslation();
  const { airplxIdentity, loginWithMagicLink } = useIdentity();
  const navigate = useNavigate();
  const { code } = useParams();

  const { loading } = useAsync(async () => {
    // convert code to token and login
    if (!code) {
      return;
    }
    await loginWithMagicLink(code);
  }, [code]);

  React.useEffect(() => {
    if (airplxIdentity?.email) {
      navigate("/");
    }
  }, [airplxIdentity]);

  if (loading) {
    return <Loading />;
  }

  if (airplxIdentity?.email) {
    return (
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="center"
        height="80vh"
        width="100%"
      >
        <Typography variant="h4">
          {t("screens.magicLinkLogin.welcome", { email: airplxIdentity.email })}
        </Typography>
      </Stack>
    );
  }

  return (
    <Stack
      direction="column"
      alignItems="center"
      justifyContent="center"
      height="80vh"
      width="100%"
    >
      <Stack direction="column" spacing={1} width={500} alignItems="center">
        <Typography variant="h4">{t("screens.magicLinkLogin.errorTitle")}</Typography>
        <Typography variant="body1" color="textSecondary">
          {t("screens.magicLinkLogin.errorMessage")}
        </Typography>
        <MagicLinkLoginButton />
      </Stack>
    </Stack>
  );
};
